import { Popup } from "../genericComponents/Popup";
import * as React from "react";
import { IGenericsLang } from "../../services/Language/Types";
import { TypeOfFinalTransaction } from "../../dtos/KioskDtos.dtos";
const greenSuccessImg = require("../../assets/images/successful-checkmark.png");

export interface ISuccessfulAppointmentConfirmPopupProps {
    isAppointmentConfirmed: boolean;
    textString: IGenericsLang;
    message: string;
    extraMessage?: React.ReactNode;
    return(potentialFinalTransaction?: TypeOfFinalTransaction): void;
}
export const SuccessfulAppointmentConfirmedPopup = (props: ISuccessfulAppointmentConfirmPopupProps): JSX.Element => {
    // tslint:disable-next-line: curly
    if (!props.isAppointmentConfirmed) return null;

    const timer = setTimeout(() => {
        props.return();
    }, 20000);
    return (
        <Popup
            visible={true}
            hidepopup={() => {
                clearTimeout(timer);
                props.return();
            }}
            title={props.textString.messagesInstructions.AppointmentHasBeenConfirmedMessage}
            closeButtonText={props.textString.labels.ExitButton}
        >
            <img src={greenSuccessImg} className="popup-image-size" />
            <h3>{props.message}</h3>
            {props.extraMessage}
        </Popup>
    );
};



// WEBPACK FOOTER //
// ./src/components/AppointmentConfirmation/SuccessfulAppointmentConfirmPopup.tsx